import { SBaseDisplay } from '@summit/core';

import { EboNameObject } from '../base-classes/ebo-name-object';
import { SpotRun } from './spot-run';

export class SpotRunSite extends EboNameObject implements SBaseDisplay {
  spotRunID: string;
  spotRun: SpotRun;
  livePackages: number;

  constructor(jsonData?: Partial<SpotRunSite>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.spotRun) {
        this.spotRun = new SpotRun(jsonData.spotRun);
      }
    }
    this.livePackages ??= 0;
  }

  toShortString(_parameters?: string): string {
    return this.name;
  }

  get defaultSort(): string {
    return this.name;
  }
}
